var root = "EDeliveryEvents.";

var EDeliveryEvents = {
    E_CONSENT_SUBMIT: root + "electronic_document_delivery_submit",
    E_CONSENT_SUBMIT_INVALID: root + "electronic_document_delivery_submit_invalid",
    
    E_DELIVERY_TOGGLE: root + "electronic_document_delivery_toggle_clicked_event",
    E_DELIVERY_CHECKBOX: root + "electronic_delivery_checkbox_clicked_event",
    EMAIL_CHOICE: root + "email_choice_selection_changed_event",
    CANCEL:root+ "electronic_delivery_cancel_event",
    AGREE: root + "agree_continue_button_clicked_event",
    SUBMIT: root + "submit_button_clicked_event", 
};

export default EDeliveryEvents;